export const easeOutCubic = [0.33, 1, 0.68, 1];
export const easeOutQuartz = [0.25, 1, 0.5, 1];
export const easeOutExpo = [0.16, 1, 0.3, 1];
